import type * as THREE from 'three';
import type { ShellFeaturePrototype } from '../../../feature/prototype/shell/ShellFeaturePrototype';
import { FeatureResultObject } from '../FeatureResultObject';

/**
 * 抽壳结果体对象。
 */
export class ShellResultObject extends FeatureResultObject<ShellFeaturePrototype> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: ShellFeaturePrototype;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
